export const CountriesConfig = [{
    id: "ir",
    available: true,
    value: "Ireland"
}, {
    id: "un",
    available: true,
    value: "United States"
}, {
    id: "af",
    available: true,
    value: "Afghanistan"
}, {
    id: "al",
    available: true,
    value: "Albania"
}, {
    id: "alg",
    available: true,
    value: "Algeria"
}, {
    id: "am",
    available: true,
    value: "American Samoa"
}, {
    id: "an",
    available: true,
    value: "Andorra"
}, {
    id: "ang",
    available: true,
    value: "Angola"
}, {
    id: "angu",
    available: true,
    value: "Anguilla"
}, {
    id: "ant",
    available: true,
    value: "Antigua and Barbuda Antigua "
}, {
    id: "ar",
    available: true,
    value: "Argentina"
}, {
    id: "arm",
    available: true,
    value: "Armenia"
}, {
    id: "aru",
    available: true,
    value: "Aruba"
}, {
    id: "au",
    available: true,
    value: "Australia"
}, {
    id: "aus",
    available: true,
    value: "Austria"
}, {
    id: "az",
    available: true,
    value: "Azerbaijan"
}, {
    id: "ba",
    available: true,
    value: "Bahamas"
}, {
    id: "bah",
    available: true,
    value: "Bahrain"
}, {
    id: "ban",
    available: true,
    value: "Bangladesh"
}, {
    id: "bar",
    available: true,
    value: "Barbados"
}, {
    id: "be",
    available: true,
    value: "Belarus"
}, {
    id: "bel",
    available: true,
    value: "Belgium"
}, {
    id: "beli",
    available: true,
    value: "Belize"
}, {
    id: "ben",
    available: true,
    value: "Benin"
}, {
    id: "ber",
    available: true,
    value: "Bermuda"
}, {
    id: "bh",
    available: true,
    value: "Bhutan"
}, {
    id: "bo",
    available: true,
    value: "Bolivia"
}, {
    id: "bon",
    available: true,
    value: "Bonaire"
}, {
    id: "bos",
    available: true,
    value: "Bosnia and Herzegovina Bosnia "
}, {
    id: "bot",
    available: true,
    value: "Botswana"
}, {
    id: "br",
    available: true,
    value: "Brazil"
}, {
    id: "bru",
    available: true,
    value: "Brunei Darussalam"
}, {
    id: "bu",
    available: true,
    value: "Bulgaria"
}, {
    id: "bur",
    available: true,
    value: "Burkina Faso"
}, {
    id: "buru",
    available: true,
    value: "Burundi"
}, {
    id: "ca",
    available: true,
    value: "Cambodia"
}, {
    id: "cam",
    available: true,
    value: "Cameroon"
}, {
    id: "can",
    available: true,
    value: "Canada"
}, {
    id: "cap",
    available: true,
    value: "Cape Verde"
}, {
    id: "cay",
    available: true,
    value: "Cayman Islands"
}, {
    id: "ce",
    available: true,
    value: "Central African Republic Central "
}, {
    id: "ch",
    available: true,
    value: "Chad"
}, {
    id: "chi",
    available: true,
    value: "Chile"
}, {
    id: "chin",
    available: true,
    value: "China"
}, {
    id: "chr",
    available: true,
    value: "Christmas Island"
}, {
    id: "co",
    available: true,
    value: "Cocos (Keeling) Islands Cocos (Keeling"
}, {
    id: "col",
    available: true,
    value: "Colombia"
}, {
    id: "com",
    available: true,
    value: "Comoros"
}, {
    id: "con",
    available: true,
    value: "Congo"
}, {
    id: "cong",
    available: true,
    value: "Congo, The Democratic Republic of Congo, The Democratic "
}, {
    id: "coo",
    available: true,
    value: "Cook Islands"
}, {
    id: "cos",
    available: true,
    value: "Costa Rica"
}, {
    id: "cot",
    available: true,
    value: "Cote D'Ivoire Cote D"
}, {
    id: "cr",
    available: true,
    value: "Croatia"
}, {
    id: "cu",
    available: true,
    value: "Cuba"
}, {
    id: "cur",
    available: true,
    value: "Curacao"
}, {
    id: "cy",
    available: true,
    value: "Cyprus"
}, {
    id: "cyp",
    available: true,
    value: "Cyprus Northern"
}, {
    id: "cz",
    available: true,
    value: "Czech Republic"
}, {
    id: "de",
    available: true,
    value: "Denmark"
}, {
    id: "dj",
    available: true,
    value: "Djibouti"
}, {
    id: "do",
    available: true,
    value: "Dominica"
}, {
    id: "dom",
    available: true,
    value: "Dominican Republic"
}, {
    id: "ec",
    available: true,
    value: "Ecuador"
}, {
    id: "eg",
    available: true,
    value: "Egypt"
}, {
    id: "el",
    available: true,
    value: "El Salvador"
}, {
    id: "eq",
    available: true,
    value: "Equatorial Guinea"
}, {
    id: "er",
    available: true,
    value: "Eritrea"
}, {
    id: "es",
    available: true,
    value: "Estonia"
}, {
    id: "et",
    available: true,
    value: "Ethiopia"
}, {
    id: "fa",
    available: true,
    value: "Falkland Islands (Malvinas) Falkland Islands "
}, {
    id: "far",
    available: true,
    value: "Faroe Islands"
}, {
    id: "fi",
    available: true,
    value: "Fiji"
}, {
    id: "fin",
    available: true,
    value: "Finland"
}, {
    id: "fr",
    available: true,
    value: "France"
}, {
    id: "fre",
    available: true,
    value: "French Guiana"
}, {
    id: "fren",
    available: true,
    value: "French Polynesia"
}, {
    id: "ga",
    available: true,
    value: "Gabon"
}, {
    id: "gam",
    available: true,
    value: "Gambia"
}, {
    id: "ge",
    available: true,
    value: "Georgia"
}, {
    id: "ger",
    available: true,
    value: "Germany"
}, {
    id: "gh",
    available: true,
    value: "Ghana"
}, {
    id: "gi",
    available: true,
    value: "Gibraltar"
}, {
    id: "gr",
    available: true,
    value: "Greece"
}, {
    id: "gre",
    available: true,
    value: "Greenland"
}, {
    id: "gren",
    available: true,
    value: "Grenada"
}, {
    id: "gu",
    available: true,
    value: "Guadeloupe"
}, {
    id: "gua",
    available: true,
    value: "Guam"
}, {
    id: "guat",
    available: true,
    value: "Guatemala"
}, {
    id: "gui",
    available: true,
    value: "Guinea"
}, {
    id: "guin",
    available: true,
    value: "Guinea Bissau"
}, {
    id: "guy",
    available: true,
    value: "Guyana"
}, {
    id: "ha",
    available: true,
    value: "Haiti"
}, {
    id: "ho",
    available: true,
    value: "Holy see (Vatican City State) Holy see (Vatican "
}, {
    id: "hon",
    available: true,
    value: "Honduras"
}, {
    id: "hong",
    available: true,
    value: "Hong Kong"
}, {
    id: "hu",
    available: true,
    value: "Hungary"
}, {
    id: "ic",
    available: true,
    value: "Iceland"
}, {
    id: "ice",
    available: true,
    value: "Iceland US Military Base Iceland US "
}, {
    id: "in",
    available: true,
    value: "India"
}, {
    id: "ind",
    available: true,
    value: "Indonesia"
}, {
    id: "ira",
    available: true,
    value: "Iran, Islamic Republic of Iran, Islamic "
}, {
    id: "iraq",
    available: true,
    value: "Iraq"
}, {
    id: "is",
    available: true,
    value: "Isle of Man Isle "
}, {
    id: "isr",
    available: true,
    value: "Israel"
}, {
    id: "it",
    available: true,
    value: "Italy"
}, {
    id: "ja",
    available: true,
    value: "Jamaica"
}, {
    id: "jap",
    available: true,
    value: "Japan"
}, {
    id: "jo",
    available: true,
    value: "Jordan"
}, {
    id: "ka",
    available: true,
    value: "Kazakhstan"
}, {
    id: "ke",
    available: true,
    value: "Kenya"
}, {
    id: "ki",
    available: true,
    value: "Kiribati"
}, {
    id: "ko",
    available: true,
    value: "Korea, Democratic People's Republic of Korea, Democratic People's "
}, {
    id: "kor",
    available: true,
    value: "Korea, Republic of Korea, "
}, {
    id: "kos",
    available: true,
    value: "Kosovo"
}, {
    id: "koso",
    available: true,
    value: "Kosovo US Military Base Kosovo US "
}, {
    id: "ku",
    available: true,
    value: "Kuwait"
}, {
    id: "ky",
    available: true,
    value: "Kyrghyz Republic US Military Base Kyrghyz Republic US "
}, {
    id: "kyr",
    available: true,
    value: "Kyrgyzstan"
}, {
    id: "la",
    available: true,
    value: "Lao, Peoples Democratic Repubic of Lao, Peoples Democratic "
}, {
    id: "lat",
    available: true,
    value: "Latvia"
}, {
    id: "le",
    available: true,
    value: "Lebanon"
}, {
    id: "les",
    available: true,
    value: "Lesotho"
}, {
    id: "li",
    available: true,
    value: "Liberia"
}, {
    id: "lib",
    available: true,
    value: "Libyan Arab Jamahiriya Libyan "
}, {
    id: "lie",
    available: true,
    value: "Liechtenstein"
}, {
    id: "lit",
    available: true,
    value: "Lithuania"
}, {
    id: "lu",
    available: true,
    value: "Luxembourg"
}, {
    id: "ma",
    available: true,
    value: "Macao"
}, {
    id: "mac",
    available: true,
    value: "Macedonia, The Former Yugoslav Republic of Macedonia, The Former Yugoslav "
}, {
    id: "mad",
    available: true,
    value: "Madagascar"
}, {
    id: "mal",
    available: true,
    value: "Malawi"
}, {
    id: "mala",
    available: true,
    value: "Malaysia"
}, {
    id: "mald",
    available: true,
    value: "Maldives"
}, {
    id: "mali",
    available: true,
    value: "Mali"
}, {
    id: "malt",
    available: true,
    value: "Malta"
}, {
    id: "mar",
    available: true,
    value: "Marshall Islands"
}, {
    id: "mart",
    available: true,
    value: "Martinique"
}, {
    id: "mau",
    available: true,
    value: "Mauritania"
}, {
    id: "maur",
    available: true,
    value: "Mauritius"
}, {
    id: "may",
    available: true,
    value: "Mayotte"
}, {
    id: "me",
    available: true,
    value: "Mexico"
}, {
    id: "mi",
    available: true,
    value: "Micronesia, Federated States of Micronesia, Federated "
}, {
    id: "mo",
    available: true,
    value: "Moldova, Republic of Moldova, "
}, {
    id: "mon",
    available: true,
    value: "Monaco"
}, {
    id: "mong",
    available: true,
    value: "Mongolia"
}, {
    id: "mont",
    available: true,
    value: "Montenegro"
}, {
    id: "monts",
    available: true,
    value: "Montserrat"
}, {
    id: "mor",
    available: true,
    value: "Morocco"
}, {
    id: "moz",
    available: true,
    value: "Mozambique"
}, {
    id: "my",
    available: true,
    value: "Myanmar"
}, {
    id: "na",
    available: true,
    value: "Namibia"
}, {
    id: "nau",
    available: true,
    value: "Nauru"
}, {
    id: "ne",
    available: true,
    value: "Nepal"
}, {
    id: "net",
    available: true,
    value: "Netherlands"
}, {
    id: "neth",
    available: true,
    value: "Netherlands Antilles"
}, {
    id: "new",
    available: true,
    value: "New Caledonia"
}, {
    id: "new ",
    available: true,
    value: "New Zealand"
}, {
    id: "ni",
    available: true,
    value: "Nicaragua"
}, {
    id: "nig",
    available: true,
    value: "Niger"
}, {
    id: "nige",
    available: true,
    value: "Nigeria"
}, {
    id: "niu",
    available: true,
    value: "Niue"
}, {
    id: "no",
    available: true,
    value: "Norfolk Island"
}, {
    id: "nor",
    available: true,
    value: "Northern Mariana Islands Northern "
}, {
    id: "norw",
    available: true,
    value: "Norway"
}, {
    id: "om",
    available: true,
    value: "Oman"
}, {
    id: "pa",
    available: true,
    value: "Pakistan"
}, {
    id: "pal",
    available: true,
    value: "Palau"
}, {
    id: "pale",
    available: true,
    value: "Palestine"
}, {
    id: "pan",
    available: true,
    value: "Panama"
}, {
    id: "pap",
    available: true,
    value: "Papua New Guinea Papua "
}, {
    id: "par",
    available: true,
    value: "Paraguay"
}, {
    id: "pe",
    available: true,
    value: "Peru"
}, {
    id: "ph",
    available: true,
    value: "Philippines"
}, {
    id: "pi",
    available: true,
    value: "Pitcairn"
}, {
    id: "po",
    available: true,
    value: "Poland"
}, {
    id: "por",
    available: true,
    value: "Portugal"
}, {
    id: "pu",
    available: true,
    value: "Puerto Rico"
}, {
    id: "qa",
    available: true,
    value: "Qatar"
}, {
    id: "re",
    available: true,
    value: "Reunion"
}, {
    id: "ro",
    available: true,
    value: "Romania"
}, {
    id: "ru",
    available: true,
    value: "Russia"
}, {
    id: "rw",
    available: true,
    value: "Rwanda"
}, {
    id: "sa",
    available: true,
    value: "Saint Helena"
}, {
    id: "sai",
    available: true,
    value: "Saint Kitts and Nevis Saint Kitts "
}, {
    id: "sain",
    available: true,
    value: "Saint Lucia"
}, {
    id: "saint",
    available: true,
    value: "Saint Pierre and Miquelon Saint Pierre "
}, {
    id: "",
    available: true,
    value: "Saint Vincent And The Grenadines Saint Vincent And "
}, {
    id: "sam",
    available: true,
    value: "Samoa"
}, {
    id: "san",
    available: true,
    value: "San Marino"
}, {
    id: "sao",
    available: true,
    value: "Sao Tome And Principe Sao Tome "
}, {
    id: "sau",
    available: true,
    value: "Saudi Arabia"
}, {
    id: "se",
    available: true,
    value: "Senegal"
}, {
    id: "ser",
    available: true,
    value: "Serbia"
}, {
    id: "sey",
    available: true,
    value: "Seychelles"
}, {
    id: "si",
    available: true,
    value: "Sierra Leone"
}, {
    id: "sin",
    available: true,
    value: "Singapore"
}, {
    id: "sl",
    available: true,
    value: "Slovakia (Slovak Republic) Slovakia ("
}, {
    id: "slo",
    available: true,
    value: "Slovenia"
}, {
    id: "so",
    available: true,
    value: "Solomon Islands"
}, {
    id: "som",
    available: true,
    value: "Somalia"
}, {
    id: "sou",
    available: true,
    value: "South Africa"
}, {
    id: "sp",
    available: true,
    value: "Spain"
}, {
    id: "sr",
    available: true,
    value: "Sri Lanka"
}, {
    id: "st",
    available: true,
    value: "ST. Maarten ST"
}, {
    id: "su",
    available: true,
    value: "Sudan"
}, {
    id: "sur",
    available: true,
    value: "Suriname"
}, {
    id: "sw",
    available: true,
    value: "Swaziland"
}, {
    id: "swe",
    available: true,
    value: "Sweden"
}, {
    id: "swi",
    available: true,
    value: "Switzerland"
}, {
    id: "sy",
    available: true,
    value: "Syrian Arab Republic Syrian "
}, {
    id: "ta",
    available: true,
    value: "Taiwan"
}, {
    id: "taj",
    available: true,
    value: "Tajikistan"
}, {
    id: "tan",
    available: true,
    value: "Tanzania"
}, {
    id: "th",
    available: true,
    value: "Thailand"
}, {
    id: "ti",
    available: true,
    value: "Timor-Leste Timor"
}, {
    id: "to",
    available: true,
    value: "Togo"
}, {
    id: "tok",
    available: true,
    value: "Tokelau"
}, {
    id: "ton",
    available: true,
    value: "Tonga"
}, {
    id: "tr",
    available: true,
    value: "Trinidad And Tobago Trinidad "
}, {
    id: "tu",
    available: true,
    value: "Tunisia"
}, {
    id: "tur",
    available: true,
    value: "Turkey"
}, {
    id: "turk",
    available: true,
    value: "Turkmenistan"
}, {
    id: "turks",
    available: true,
    value: "Turks And Caicos Islands Turks And "
}, {
    id: "tuv",
    available: true,
    value: "Tuvalu"
}, {
    id: "ug",
    available: true,
    value: "Uganda"
}, {
    id: "uk",
    available: true,
    value: "Ukraine"
}, {
    id: "uni",
    available: true,
    value: "United Arab Emirates United "
}, {
    id: "unit",
    available: true,
    value: "United Kingdom"
}, {
    id: "unite",
    available: true,
    value: "United States minor outlying islands United States minor "
}, {
    id: "ur",
    available: true,
    value: "Uruguay"
}, {
    id: "uz",
    available: true,
    value: "Uzbekistan"
}, {
    id: "va",
    available: true,
    value: "Vanuatu"
}, {
    id: "ve",
    available: true,
    value: "Venezuela"
}, {
    id: "vi",
    available: true,
    value: "Viet Nam"
}, {
    id: "vir",
    available: true,
    value: "Virgin Islands, British Virgin Islands"
}, {
    id: "virg",
    available: true,
    value: "Virgin Islands, U.S. Virgin Islands, U"
}, {
    id: "wa",
    available: true,
    value: "Wallis And Futuna Wallis "
}, {
    id: "we",
    available: true,
    value: "Western Sahara"
}, {
    id: "ye",
    available: true,
    value: "Yemen"
}, {
    id: "za",
    available: true,
    value: "Zambia"
}, {
    id: "zi",
    available: true,
    value: "Zimbabwe"
}];